import {IApplication} from "../../../Interfaces/Application/IApplication";
import CardHeader from "@mui/material/CardHeader";
import AlbumIcon from "@mui/icons-material/Album";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import Grid, {GridProps} from "@mui/material/Grid";
import {divide, formatPhoneNumber, hasValue, multiply, toDollars} from "@amsanalytics/react-shared-library";
import Card from "@mui/material/Card";
import {Constants} from "../../../utils/constants";
import {IQuote} from "../../../Interfaces/Common/IQuote";
import {usePricingPrograms} from "../../../Data/LookupData";
import {IAppCustomer} from "../../../Interfaces/Application/IAppCustomer";
import { calculateLTV } from "../../../utils/quoteUtils";
import {useSelector} from "react-redux";
import {AppState} from "../../../store/rootReducer";

export interface IndirectApplicationDecisionInfoCardProps {
  primaryApplicant: IAppCustomer | undefined
  currentApp: IApplication;
  underwriterQuote: IQuote | undefined;
  labelProps: GridProps<"div", {}>;
  valueProps: GridProps<"div", {}>;
}

export const IndirectApplicationDecisionInfoCard = (props: IndirectApplicationDecisionInfoCardProps) => {
  const { data: pricingPrograms } = usePricingPrograms();
  const amountApproved = props.underwriterQuote?.amountToFinance?.toFixed(2);
  const term = props.underwriterQuote?.quotePayTypeId?.toLowerCase() === Constants.biweeklyPayTypeId 
    ? divide(multiply(props.underwriterQuote?.term ?? 0, 26), 12) 
    : props.underwriterQuote?.term;
  const acquisitionFee = props.underwriterQuote?.bankFee;
  const buyRate = props.underwriterQuote?.apr;
  const tierLevel = pricingPrograms?.find(x => x.id === props.underwriterQuote?.pricingProgramId)?.name;
  const ficoScore = props.primaryApplicant?.customer?.customerCredit?.[0]?.bureauScore;
  const ltvRatio = props.underwriterQuote && calculateLTV(props.underwriterQuote, props.currentApp.vehicle, true);
  const totalEquityRequired = props.currentApp.applicationCustomFields?.find(x => x.customField?.name === 'Total Equity Required');
  const lookups = useSelector((state: AppState) => state.applications.lookups);
  const organizationsOnApp = lookups.organizations.find(o => o.id === props.currentApp.organizationId);
  const titleTextStyle = { fontWeight: 'bold', color: '1f1d1d' };
  return (
    <Card>
      <CardHeader
        avatar={<AlbumIcon fontSize="small" />}
        title={`${props.currentApp.appSource} Info`}
      />
      <Divider variant="middle" />
      <CardContent>
        <Grid container>
          <Grid item {...props.labelProps} style={titleTextStyle}>Dealer Contact:</Grid>
          <Grid item {...props.valueProps}>{organizationsOnApp?.contactName ?? ''}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>Dealer Phone:</Grid>
          <Grid item {...props.valueProps}>{formatPhoneNumber(organizationsOnApp?.storePhoneNumber) ?? ''}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>Dealer Address:</Grid>
          <Grid item {...props.valueProps}>{organizationsOnApp?.mapAddress ?? ''}</Grid>
          
          <Grid item {...props.labelProps} style={titleTextStyle}>Amount Approved:</Grid>
          <Grid item {...props.valueProps}>{hasValue(amountApproved) ? toDollars(Number(amountApproved)) : ''}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>Term:</Grid>
          <Grid item {...props.valueProps}>{term}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>Acquisition Fee:</Grid>
          <Grid item {...props.valueProps}>{acquisitionFee}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>Buy Rate:</Grid>
          <Grid item {...props.valueProps}>{buyRate}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>Tier Level:</Grid>
          <Grid item {...props.valueProps}>{tierLevel}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>Fico Score:</Grid>
          <Grid item {...props.valueProps}>{ficoScore}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>LTV Ratio:</Grid>
          <Grid item {...props.valueProps}>{ltvRatio}</Grid>

          <Grid item {...props.labelProps} style={titleTextStyle}>{totalEquityRequired && 'Total Equity Required:'}</Grid>
          <Grid item {...props.valueProps}>{totalEquityRequired && totalEquityRequired?.value}</Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}